import { MijnRoute } from '../../mijn-navigatie.model';

export const PAYMENTS_OVERVIEW: MijnRoute = {
    path: 'verzendlijst',
    navigationEvent: 'toVerzendlijst',
    regex: /^\/overboeken\/verzendlijst$/,
    webcomponent: 'mijn-overboeken-webcomponent',
    internalPath: '/verzendlijst'
};
